import { render } from "./TarotDetailTableOfContents.vue?vue&type=template&id=f281d628&scoped=true"
import script from "./TarotDetailTableOfContents.vue?vue&type=script&lang=js"
export * from "./TarotDetailTableOfContents.vue?vue&type=script&lang=js"

import "./TarotDetailTableOfContents.vue?vue&type=style&index=0&id=f281d628&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f281d628"]])

export default __exports__